import React from "react"
import styles from "./Wrapper.module.scss"
import classnames from "classnames/bind"

// A container with the default spacing for desktop
const Wrapper = props => {
  // Placement: "left", "right" or default applies both
  let classNames

  if (props.gap === "outer") {
    if (props.placement === "left") {
      classNames = classnames(props.className, styles.leftContainerOuterGap)
    } else if (props.placement === "right") {
      classNames = classnames(props.className, styles.rightContainerOuterGap)
    } else {
      classNames = classnames(
        props.className,
        styles.leftContainerOuterGap,
        styles.rightContainerOuterGap
      )
    }
  } else {
    if (props.placement === "left") {
      classNames = classnames(props.className, styles.leftContainer)
    } else if (props.placement === "right") {
      classNames = classnames(props.className, styles.rightContainer)
    } else {
      classNames = classnames(
        props.className,
        styles.leftContainer,
        styles.rightContainer
      )
    }
  }

  return <div className={classNames}>{props.children}</div>
}

export default Wrapper
